interface ErrorTextComponentProps {
  error: string;
}

export function ErrorTextComponent(props: Readonly<ErrorTextComponentProps>) {
  const { error } = props;

  if (!error || error.length === 0) return null;
  return (
    <span className="text-xs font-medium text-destructive animate-in slide-in-from-top-1">
      {error}
    </span>
  );
}
